<template>
	<section
		class="p-6 rounded-lg bg-neutral-900"
		data-test="insights-methodology-card"
	>
		<h3 class="mb-4 text-lg font-black text-white uppercase font-heading">
			{{ $t('personality_results.insights_methodology.heading') }}
		</h3>

		<ul class="mb-0 space-y-2">
			<li
				v-for="item in items"
				:key="item"
				class="flex items-center gap-2 text-sm text-grey-300"
			>
				<IconCheckCircle size="16" class="shrink-0 text-grey-400" />
				<span>{{ $t(item) }}</span>
			</li>
		</ul>

		<hr class="my-4 border-[#363636]" />

		<p class="mb-0 text-sm text-grey-500">
			{{ $t(`personality_results.insights_methodology.footer.${side}`) }}
		</p>
	</section>
</template>

<script>
import { IconCheckCircle } from '~/components/Icons'

export default {
	name: 'InsightsMethodologyCard',
	components: {
		IconCheckCircle
	},
	props: {
		side: {
			type: String,
			default: 'company',
			validator: value => ['company', 'applicant'].includes(value)
		}
	},
	computed: {
		items() {
			return [
				`personality_results.insights_methodology.items.${this.side}.assessment`,
				`personality_results.insights_methodology.items.${this.side}.comparison`,
				`personality_results.insights_methodology.items.${this.side}.dimensions`
			]
		}
	}
}
</script>
